export default __webpack_public_path__ + "static/media/about-halu-lp.33894084.png";